import { axiosService } from "@/services/AxiosService";

/**
 * @typedef {Object} HorseWeight
 * @property {number} id - ID del record di peso
 * @property {number} horse_id - ID del cavallo associato
 * @property {string} weight - Peso del cavallo
 * @property {string} date - Data di registrazione del peso
 * @property {string} created - Data di creazione del record
 * @property {string} modified - Data di modifica del record
 */



/**
 * Servizio per gestire le informazioni dei cavalli.
 */
class HorsesWeightService {

    abortController = null;

    constructor() {
        this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
    }

    /**
     * 
     * @returns {Promise<HorseWeight[]>} - 
     * @throws {Error} - 
     */
    async getHorseWeights(page, search = '', params = {}, length = 10) {
        try {
            const response = await this.axiosInstance.post('/horse-weights/get-horse-weights', {page, length, search, ...params});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse weights info');
            }

            /** @type {HorseWeight[]} */
            return response.data;
        } catch (error) {
            console.error('Error fetching horse weights info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    /**
     * 
     * @returns {Promise<HorseWeight[]>} - 
     * @throws {Error} - 
     */
    async getHorseWeightsById(id) {
        try {
            const response = await this.axiosInstance.post('/horse-weights/get-horse-weight-given-id', {horse_weight_id: id});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse weights info');
            }

            /** @type {HorseWeight} */
            return response.data.data.weight;
        } catch (error) {
            console.error('Error fetching horse weights info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    /**
     * 
     * @returns {Promise<HorseWeight>} 
     * @throws {Error} 
     */
    async saveHorseWeight(data) {
        try {
            
            const response = await this.axiosInstance.post('/horse-weights/saveHorseWeight', data);

            if (response.status !== 200) {
                throw new Error('Failed to save horse weight data');
            }

            /** @type {HorseWeight} */
            const weight = response.data.data.weight;
            return weight;
        } catch (error) {
            console.error('Error saving horse weight:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    
}

export const horsesWeightService = new HorsesWeightService();
